import script from "./RejectTireModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RejectTireModal.vue?vue&type=script&setup=true&lang=ts"

import "./RejectTireModal.vue?vue&type=style&index=0&id=25d930e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d930e0"]])

export default __exports__